import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5 17a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1"
    />
    <path
      fill="currentColor"
      d="M14 11.5a1 1 0 0 1-.71-.29l-1.79-1.8-1.79 1.8a1.004 1.004 0 1 1-1.42-1.42l2.5-2.5a1 1 0 0 1 1.42 0l2.5 2.5a1 1 0 0 1 0 1.42 1 1 0 0 1-.71.29"
    />
  </svg>
);
export default SvgArrowUpSmall;
